<template>
  <v-dialog
    v-model="isVisibleDialog"
    persistent
    max-width="600px"
  >
    <v-form
      ref="form"
      lazy-validation
    >
      <v-card>
        <v-card-title>
          <span class="text-h3">{{ $t("edit") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="oem.oem_name"
                  dense
                  :label="$t('oem_name_*')"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="oem.oem_email"
                  dense
                  :label="$t('oem_email_*')"
                  :rules="[rules.required, rules.email]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="oem.user_name"
                  dense
                  :label="$t('poc_name_*')"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="oem.user_email"
                  dense
                  disabled
                  :label="$t('poc_email_*')"
                  :rules="[rules.required, rules.email]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="oem.contact_no"
                  dense
                  type="number"
                  :label="$t('contact_*')"
                  :rules="[
                    rules.required,
                    rules.min_length(8),
                    rules.max_length(11),
                  ]"
                />
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="oem.address"
                  dense
                  :label="$t('address_*')"
                  :rules="[rules.required]"
                />
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="oem.business_uuid"
                  dense
                  disabled
                  :label="$t('user_id')"
                  :rules="[rules.required]"
                />
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <!-- :placeholder="oem.business_logo ? '' : oem.logo_url" -->
                <v-file-input
                  v-model="oem.business_logo"
                  dense
                  accept="image/png, image/jpeg, image/bmp"
                  prepend-icon="mdi-camera"
                  :label="$t('business_logo_*')"
                  :rules="[rules.file_size]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="oem.no_of_users_account"
                  dense
                  type="number"
                  :min="3"
                  :label="$t('no_of_users_*')"
                  :rules="[rules.min_quantity(3)]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-img
                  lazy-src="https://picsum.photos/id/11/10/6"
                  max-height="100"
                  max-width="100"
                  :src="oem.logo_url"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small>{{ $t("indicates_required_field") }}</small>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="toggleEdit()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="isLoadingSave"
            @click="updateItem(oem)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
// import { mapGetters } from "vuex";
import { validationRules } from "@/mixins/validationRules";

export default {
  mixins: [validationRules],
  props: {
    isVisibleDialog: Boolean,
    toggleEdit: {
      type: Function,
      default() {
        return void 0;
      },
    },
    oem: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      isLoadingSave: false,
    };
  },
  // async beforeMount() {
  //   // Set business Logo Name
  //   let nameArr = this.oem.logo_url.split("/");
  //   let index = nameArr.length - 1;
  //   const name = nameArr[index];
  //   const ext = name.split(".")[1];
  //   const f = new File([""], name, { type: `image/${ext}` });
  //   this.oem.business_logo = f;
  // },
  methods: {
    async updateItem(oem) {
      if (this.$refs.form.validate()) {
        this.isLoadingSave = true;

        this.oem.name = this.oem.oem_name;
        this.oem.email = this.oem.user_email;
        await this.$store
          .dispatch("oemclients/update", oem)
          .then(async () => {
            await this.$store.dispatch("oemclients/list");
            this.$store.dispatch(
              "alerts/success",
              this.$t("updated_successfully")
            );
            this.isLoadingSave = false;
            this.toggleEdit();
          })
          .catch((error) => {
            this.$store.dispatch("alerts/error", error.response?.data?.message);
            this.isLoadingSave = false;
          });
      }
    },
  },
};
</script>
